/**
 * Frontend runtime config.
 * Local feel-test: leave VITE_API_BASE empty — Vite mock serves /api.
 */

export const GAME_ID = 'voxel-quest';
export const GAME_NAME = import.meta.env.VITE_GAME_NAME || 'Voxel Quest';
export const BOT_USERNAME = import.meta.env.VITE_BOT_USERNAME || '';

/** Telegram usernames (no @) allowed to see debug / peek tools in production. */
export const DEBUG_TELEGRAM_USERNAMES = ['ikorkin'];

/** True when running against the Vite in-memory mock (default for npm run dev). */
export const IS_LOCAL_MODE =
  import.meta.env.DEV &&
  import.meta.env.VITE_USE_WRANGLER !== '1' &&
  import.meta.env.VITE_USE_WRANGLER !== 'true';

/**
 * Dev drawer, model validator, PEEK, auto-solve — local feel-test OR allowlisted Telegram user.
 */
export function canUseDebugTools() {
  if (IS_LOCAL_MODE) return true;
  if (typeof window === 'undefined') return false;
  const host = window.location.hostname;
  if (host === 'localhost' || host === '127.0.0.1') return true;
  const username = window.Telegram?.WebApp?.initDataUnsafe?.user?.username;
  if (!username) return false;
  const normalized = String(username).replace(/^@/, '').toLowerCase();
  return DEBUG_TELEGRAM_USERNAMES.some((u) => u.toLowerCase() === normalized);
}

export function getApiBase() {
  const raw = (import.meta.env.VITE_API_BASE || '').replace(/\/$/, '');
  return raw ? `${raw}/api/game/mystery` : '/api/game/mystery';
}

export function getProgressApiBase() {
  const raw = (import.meta.env.VITE_API_BASE || '').replace(/\/$/, '');
  return raw ? `${raw}/api/game/progress` : '/api/game/progress';
}

export function getSquadApiBase() {
  const raw = (import.meta.env.VITE_API_BASE || '').replace(/\/$/, '');
  return raw ? `${raw}/api/syndicate` : '/api/syndicate';
}
